import { Group, Text } from '@mantine/core';

const HEALTH_CONFIG: Record<string, { color: string; dotColor: string; label: string }> = {
  at_risk: { color: 'red', dotColor: '#D64545', label: 'At Risk' },
  monitor: { color: 'yellow', dotColor: '#E9A23B', label: 'Monitor' },
  on_track: { color: 'green', dotColor: '#4A7C59', label: 'Healthy' },
  no_data: { color: 'gray', dotColor: '#888888', label: 'No Data' },
};

export function renderCohortHealthBadge(healthStatus: string | null) {
  if (!healthStatus) {
    return <Text size="sm" c="dimmed">&mdash;</Text>;
  }
  const config = HEALTH_CONFIG[healthStatus];
  if (!config) {
    return <Text size="sm" c="dimmed">&mdash;</Text>;
  }
  return (
    <Group gap={6} wrap="nowrap">
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: config.dotColor,
          display: 'inline-block',
          flexShrink: 0,
        }}
      />
      <Text fz={12} fw={500} c={config.dotColor}>
        {config.label}
      </Text>
    </Group>
  );
}
